// eslint-disable-next-line no-unused-vars
function processNode(node = {}) {
    if (!node.content?.length) {
        return;
    }

    const content = [];
    while (node.content.length) {
        let child = node.content.shift();

        if (child.type === "citation") {
            const group = {
                type: "citation-group",
                attrs: { id: [] },
            };

            while (child?.type === "citation") {
                group.attrs.id.push(child.attrs.id);
                child = node.content.shift();
            }

            content.push(group);
        }

        if (child) {
            content.push(child);

            if (child.content) {
                processNode(child);
            }
        }
    }

    node.content = content;
}

export function processCitations(content) {
    // FIXME: Enable when migrating to the new comment selection scheme
    // processNode(content);
    return content;
}
